module.exports = __webpack_public_path__ + "static/media/sample-collaboration-guide.5a779507.pdf";